import { authService } from '@/services/auth.service'
import type { Router } from 'vue-router'

export const activateAuthGuard = (router: Router) => {
  router.beforeEach((to) => {
    if (!authService.isAuthorized && to.name !== 'auth') {
      return '/auth'
    }
  })
}
